<template>
  <div>
    <div class="containar">
      <div class="contents-block">
        <div class="preview-area">
          <div class="preview-header">
            <h3>プレビュー</h3>
          </div>
          <div class="voice-container">
            <ul class="voice-states">
              <li class="voice-state">
                <img
                  class="avatar color1"
                  :src="imgPath"
                  :class="[borderRadiusClass, animationClass]"
                />
                <div class="user">
                  <span class="name" :style="{ background: nameColor.hex8 }" :class="nameShapeClass">User1</span>
                </div>
              </li>
              <li class="voice-state">
                <img
                  class="avatar color2"
                  :src="imgPath"
                  :class="[borderRadiusClass, blightStyle]"
                />
                <div class="user">
                  <span class="name" :style="{ background: nameColor.hex8 }" :class="nameShapeClass">User2</span>
                </div>
              </li>
              <li class="voice-state">
                <img
                  class="avatar color3"
                  :src="imgPath"
                  :class="[borderRadiusClass, blightStyle]"
                />
                <div class="user">
                  <span class="name" :style="{ background: nameColor.hex8 }" :class="nameShapeClass">User3</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="set">
          <h3>アイコンの形</h3>
          <div class="toggle-group">
            <label class="toggle-option">
              <input type="radio" value="0%" v-model="borderRadius" />
              <span class="toggle-label">四角</span>
            </label>
            <label class="toggle-option">
              <input type="radio" value="38%" v-model="borderRadius" />
              <span class="toggle-label">角まる</span>
            </label>
            <label class="toggle-option">
              <input type="radio" value="50%" v-model="borderRadius" />
              <span class="toggle-label">まる</span>
            </label>
          </div>

          <h3>アニメーション</h3>
          <div class="toggle-group">
            <label class="toggle-option">
              <input type="radio" value="fuwafuwa" v-model="selectedAnimation" />
              <span class="toggle-label">ふわふわ</span>
            </label>
            <label class="toggle-option">
              <input type="radio" value="pyoko" v-model="selectedAnimation" />
              <span class="toggle-label">ぴょこぴょこ</span>
            </label>
            <label class="toggle-option">
              <input type="radio" value="none" v-model="selectedAnimation" />
              <span class="toggle-label">なし</span>
            </label>
          </div>

          <h3>名前の形</h3>
          <div class="toggle-group">
            <label class="toggle-option">
              <input type="radio" value="default" v-model="nameShape" />
              <span class="toggle-label">デフォルト</span>
            </label>
            <label class="toggle-option">
              <input type="radio" value="round" v-model="nameShape" />
              <span class="toggle-label">角まる</span>
            </label>
          </div>

          <h3>名前のカラー選択</h3>
          <div class="color-picker-wrapper">
            <chrome-picker :value="nameColor" v-model="nameColor" />
          </div>

          <h3>コピペ用CSS</h3>
          <div class="url-description">
            <p>DiscordオーバレイのカスタムCSSです。<a href="https://reactive.fugi.tech/" target="_blank" rel="noopener noreferrer">Discord Reactive</a>で動作します。</p>
            <p>OBSのブラウザソースにあるカスタムCSSに下記のコードをコピペしてください。</p>

          </div>
          <div class="url-container">
            <textarea id="target" readonly class="url-input textarea" v-model="generatedCSS" />
            <button @click="copyCSS" class="url-copy-btn">
              <span>コピー</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Chrome } from 'vue-color';

export default {
  name: "DiscordCssCustomizer",
  components: {
    'chrome-picker': Chrome,
  },
  data() {
    return {
      imgPath: require('@/assets/discord-icon.png'),
      borderRadius: '38%',
      selectedAnimation: 'fuwafuwa',
      nameShape: 'default',
      nameColor: {
        hex: '#1e2124',
        hex8: '#1e2124FF',
        hsl: { h: 210, s: 0.06, l: 0.12, a: 1 },
        rgba: { r: 30, g: 33, b: 36, a: 1 },
        a: 1,
      },
      animations: {
        fuwafuwa: `@keyframes fuwafuwa{0%{transform:translate(0,0)rotate(-5deg);}50%{transform:translate(0,-5px)rotate(0deg);}100%{transform:translate(0,0)rotate(5deg);}}`,
        pyoko: `@keyframes pyoko{0%{transform:translate(0,0)rotate(0deg);}50%{transform:translate(0,-10px)rotate(0deg);}100%{transform:translate(0,0)rotate(0deg);}}`,
      },
    };
  },
  computed: {
    borderRadiusClass() {
      return `border-radius-${this.borderRadius.replace('%', '')}`;
    },
    animationClass() {
      return this.selectedAnimation !== 'none' ? this.selectedAnimation : '';
    },
    blightStyle() {
      return this.selectedAnimation !== 'none' ? 'brightness' : '';
    },
    nameShapeClass() {
      return this.nameShape === 'round' ? 'name-radius-round' : 'name-radius-default';
    },
    nameRadiusValue() {
      return this.nameShape === 'round' ? '18px' : '3px';
    },
    generatedCSS() {
      const a = this.selectedAnimation !== "none" ? this.animations[this.selectedAnimation] : "";
      const b = this.selectedAnimation !== "none" ? `[data-speaking="true"] canvas{animation:${this.selectedAnimation} 300ms infinite linear alternate;}` : '';
      return `#embed [data-discord-id] canvas{width:100%!important;height:100%!important;aspect-ratio:1/1!important;object-fit:contain!important;flex:none!important;border-radius:${this.borderRadius};}${a}${b}#embed .h-screen{flex-direction:row!important;flex-wrap:wrap!important;justify-content:flex-start!important;align-items:flex-end!important;align-content:flex-end!important;padding-bottom:2.5rem!important;}#embed .h-screen>.flex>.flex{gap:1rem!important;}#embed [data-discord-id]{flex:0 0 250px!important;width:250px!important;max-width:250px!important;padding-bottom:46px!important;}#embed [data-discord-id]>.relative{width:100%!important;height:auto!important;aspect-ratio:1/1!important;position:relative!important;padding-bottom:0!important;}#embed [data-discord-id] .text-center{display:block!important;position:absolute!important;top:calc(100% + 8px)!important;right:auto!important;bottom:auto!important;left:50%!important;transform:translateX(-50%)!important;width:calc(100% - 1.5rem)!important;margin:0!important;font-size:18px!important;line-height:1.2!important;color:#fff!important;background-color:${this.nameColor.hex8}!important;-webkit-text-stroke:0!important;-webkit-text-stroke-width:0!important;-webkit-text-stroke-color:transparent!important;text-shadow:none!important;border-radius:${this.nameRadiusValue}!important;padding:8px 16px!important;font-weight:600!important;box-sizing:border-box!important;text-overflow:ellipsis!important;overflow:hidden!important;white-space:nowrap!important;}`;
    },
  },
  methods: {
    copyCSS() {
      navigator.clipboard.writeText(this.generatedCSS).then(
        () => {
          alert("CSSをコピーしました！");
        },
        () => {
          alert("コピーに失敗しました。");
        }
      );
    },
  },
};
</script>

<style scoped>
p {
  margin: 0;
  padding: 0;
  font-size: 14px;
}

h3{
  font-size: 14px;
  margin-top: 24px;
  margin-bottom: 0;
}

.containar{
  margin: 0 auto;
  width: 100%;
}

/* Layout Styles */
.contents-block{
  display: -webkit-flex;
	display: flex;
	-webkit-flex-wrap: nowrap;
	flex-wrap: nowrap;
	-webkit-justify-content: space-around;
	justify-content: space-around;
	-webkit-align-items: flex-start;
	align-items: flex-start;
  margin: 24px auto;
  gap: 24px;
}

@media screen and (max-width: 767px) {
  .contents-block{
    display: block;
    margin: 0 auto;
  }

  .set{
    margin-top:24px;
    margin-left: 0;
  }
}

.set{
  flex: 1;
  max-width: 420px;
  padding: 8px 12px 24px 12px;
  background-color: #FFFEF9;
  border-radius: 10px;
}

/* プレビューエリア */
.preview-area{
  flex: 1;
  max-width: 420px;
  min-width: 320px;
}

.preview-header{
  padding: 2px 12px;
  margin-bottom: 16px;
}

.voice-container{
  margin-bottom: 48px;
    font-weight: 600;
    font-size: 16px;
    line-height: 19px;
    color: #fff;
}

.voice-states{
  list-style-type: none;
  padding-left: 15px;
  display: flex;
  margin-bottom: 3px;
  --avatar-size: 96px;
}

.voice-container .voice-states .voice-state {
  height: auto;
  margin-bottom: 5px;
  margin-right: 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

ul {
    display: block;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    padding-inline-start: 40px;
}

li {
    display: list-item;
    text-align: -webkit-match-parent;
    vertical-align: middle;
}

.voice-container .voice-states .voice-state .avatar {
    border: 3px solid transparent;
    float: none;
    margin-right: 0;
    margin-bottom: 0;
    object-fit: scale-down;
    padding: 5px;
    box-sizing:border-box;
    height: var(--avatar-size, 56px);
    width: var(--avatar-size, 56px);
}

.name-radius-default { border-radius: 3px; }
.name-radius-round { border-radius: 18px; }

.speaking{
  border-color: #43b581 !important;
}

.border-radius-0 {
  border-radius: 0%;
}

.border-radius-38 {
  border-radius: 38%;
}

.border-radius-50 {
  border-radius: 50%;
}

.color1 {
  background-color: blue;
}

.color2 {
  background-color: lightcoral;
}

.color3 {
  background-color: lightgreen;
}

.fuwafuwa {
  animation:fuwafuwa 300ms infinite linear alternate;
  filter: brightness(100%);
  border-color: transparent!important;
}
.pyoko {
  animation:pyoko 300ms infinite linear alternate;
  filter: brightness(100%);
  border-color: transparent!important;
}

.brightness {
  filter: brightness(70%);
}

.result {
  margin-top: 30px;
}

/* Toggle Group (Radio Buttons) */
.toggle-group {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 12px;
}

.toggle-option {
  position: relative;
  cursor: pointer;
}

.toggle-option input[type="radio"] {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.toggle-label {
  display: inline-block;
  padding: 8px 16px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #ffffff;
  color: #64748b;
  font-size: 13px;
  font-weight: 500;
  transition: all 0.2s ease;
  min-width: 60px;
  text-align: center;
}

.toggle-option input[type="radio"]:checked + .toggle-label {
  background: #0f172a;
  color: #ffffff;
  border-color: #0f172a;
}

.toggle-option:hover .toggle-label {
  border-color: #cbd5e1;
}

/* Color Picker */
.color-picker-wrapper {
  margin-top: 12px;
}

.color-picker-wrapper .vc-chrome {
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1), 0 0 0 1px #e2e8f0;
  font-family: system-ui, -apple-system, sans-serif;
}

/* URL Section */
.option-description {
  font-size: 12px;
  color: #718096;
  margin: 8px 0 0 0;
  line-height: 1.5;
}

.url-description {
  margin: 12px 0 16px 0;
}

.url-description p {
  font-size: 13px;
  color: #718096;
  margin: 0 0 6px 0;
  line-height: 1.5;
}

.url-description a {
  color: #0f172a;
  text-decoration: underline;
}

.url-description a:hover {
  color: #1e293b;
}

.url-container {
  display: flex;
  gap: 8px;
  align-items: stretch;
  margin-bottom: 16px;
}

.url-input {
  flex: 1;
  height: 2.4em;
  padding: 0 12px;
  border-radius: 4px;
  border: none;
  box-shadow: 0 0 0 1px #ccc inset;
  font-size: 12px;
  background: #f8fafc;
  color: #4a5568;
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
  line-height: 1.4;
  resize: vertical;
}

.url-input.textarea {
  height: 80px;
  padding: 12px;
  resize: vertical;
}

.url-input:focus {
  outline: none;
  box-shadow: 0 0 0 2px #0f172a;
}

.url-copy-btn {
  padding: 0 20px;
  height: 2.4em;
  background: #0f172a;
  color: #ffffff;
  border: none;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  display: flex;
  align-items: center;
  justify-content: center;
}

.url-copy-btn:hover {
  background: #0f172a;
  transform: translateY(-1px);
}

.url-copy-btn:active {
  transform: translateY(0);
}

@keyframes fuwafuwa {
  0% { transform: translate(0, 0) rotate(-5deg); }
  50% { transform: translate(0, -5px) rotate(0deg); }
  100% { transform: translate(0, 0) rotate(5deg); }
}

@keyframes pyoko {
  0% { transform: translate(0, 0) rotate(0deg); }
  50% { transform: translate(0, -10px) rotate(0deg); }
  100% { transform: translate(0, 0) rotate(0deg); }
}

.voice-container .voice-states .voice-state .user {
  width: var(--avatar-size, 56px);
  padding-top: 0;
  margin-top: 8px;
}

.voice-container .voice-states .voice-state .user .name {
  text-align: center;
  width: 100%;
  max-width: var(--avatar-size, 56px);
  color: white;
  font-size: 18px;
  line-height: 1.2;
  padding: 4px 6px;
  box-sizing: border-box;
  overflow: hidden;
  display: block;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.reactive-settings-img{
    width: 100%;
    max-width: 350px;
    margin: 12px 0;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
</style>